var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"iframe",attrs:{"scrolling":"no","frameborder":"0","src":"https://qn.cache.wpscdn.cn/encs/doc/office_v13/index.htm?a=123"}})}
var staticRenderFns = []

export { render, staticRenderFns }